import { render } from "./StudentResource.vue?vue&type=template&id=01aaa477&scoped=true"
import script from "./StudentResource.vue?vue&type=script&lang=js"
export * from "./StudentResource.vue?vue&type=script&lang=js"

import "./StudentResource.vue?vue&type=style&index=0&id=01aaa477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01aaa477"]])

export default __exports__